module.exports = __webpack_public_path__ + "img/journal-frame-bg.1741ab4b.png";